import React from 'react';
import { Shield, Lock, Award, CheckCircle, Globe, Users } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      title: 'SSL Secured',
      description: '256-bit encryption',
      color: 'emerald'
    },
    {
      icon: Lock,
      title: 'Data Protection',
      description: 'GDPR Compliant',
      color: 'cyan'
    },
    {
      icon: Award,
      title: 'Award Winning',
      description: 'Best AI Trading 2024',
      color: 'yellow'
    },
    {
      icon: CheckCircle,
      title: 'Verified',
      description: 'Licensed & Regulated',
      color: 'blue'
    },
    {
      icon: Globe,
      title: 'Global Trading',
      description: '150+ Countries',
      color: 'purple'
    },
    {
      icon: Users,
      title: 'Trusted',
      description: '10,000+ Active Users',
      color: 'emerald'
    }
  ];

  const colorMap = {
    emerald: 'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30 text-emerald-400',
    cyan: 'from-cyan-500/20 to-cyan-600/20 border-cyan-500/30 text-cyan-400',
    yellow: 'from-yellow-500/20 to-yellow-600/20 border-yellow-500/30 text-yellow-400',
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30 text-blue-400',
    purple: 'from-purple-500/20 to-purple-600/20 border-purple-500/30 text-purple-400'
  };

  return (
    <section className="relative bg-gradient-to-b from-slate-950 to-black py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h3 className="text-2xl font-bold text-white mb-2">
            Trusted & <span className="text-emerald-400">Secure</span>
          </h3>
          <p className="text-slate-400 text-sm">Your safety is our priority</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-7xl mx-auto">
          {badges.map((badge) => {
            const Icon = badge.icon;
            return (
              <div
                key={badge.title}
                className={`bg-gradient-to-br ${colorMap[badge.color]} backdrop-blur-sm border rounded-xl p-4 text-center hover:scale-105 transition-all duration-300`}
              >
                <Icon className={`w-8 h-8 mx-auto mb-2 ${colorMap[badge.color].split(' ')[2]}`} />
                <div className="text-white font-bold text-xs mb-1">{badge.title}</div>
                <div className="text-slate-400 text-xs">{badge.description}</div>
              </div>
            );
          })}
        </div>

        {/* Security Certifications */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 opacity-50">
          <div className="text-slate-500 text-xs font-semibold">🔒 PCI DSS Compliant</div>
          <div className="text-slate-500 text-xs font-semibold">🛡️ ISO 27001 Certified</div>
          <div className="text-slate-500 text-xs font-semibold">✅ SOC 2 Type II</div>
          <div className="text-slate-500 text-xs font-semibold">🔐 2FA Enabled</div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
